var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirstComment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9141 115.234V120.641H41.7422V122.094H39.9141V129.391H38.1797V115.234H39.9141ZM28.9141 125.844V116.703H32.5547V118.109H30.6484V124.391C31.2812 124.367 31.9297 124.305 32.6641 124.156L32.8047 125.578C31.5859 125.82 30.625 125.836 29.6016 125.844H28.9141ZM33.3203 125.844V116.703H37.1172V118.109H35.0234V124.398C35.9766 124.383 36.6562 124.312 37.3984 124.125L37.5391 125.547C36.4922 125.812 35.6328 125.836 34.0391 125.844H33.3203ZM55.2891 121.891V123.297H42.4141V121.891H55.2891ZM43.3516 127.953C46.2734 127.602 47.9766 126.172 47.9766 124.531V124.203H49.7422V124.531C49.7422 126.172 51.4531 127.602 54.3984 127.953L53.7578 129.312C51.4766 128.992 49.7344 128.047 48.8672 126.672C48 128.047 46.2656 128.992 43.9766 129.312L43.3516 127.953ZM43.6172 120.844V115.953H48.5234V117.328H45.3516V119.445C46.4844 119.43 47.5 119.344 48.6328 119.094L48.7891 120.5C47.2969 120.805 46.0391 120.836 44.4609 120.844H43.6172ZM49.2578 120.844V115.953H54.0703V117.328H51.0078V119.453H54.1641V120.844H49.2578ZM67.3828 115.266V118.844H69.3516V120.297H67.3828V123.781H65.6484V115.266H67.3828ZM56.2578 118.016V116.625H59.5859V115.172H61.3203V116.625H64.6328V118.016H56.2578ZM56.9766 121.062C56.9766 119.555 58.3828 118.531 60.4453 118.531C62.4922 118.531 63.8906 119.555 63.8984 121.062C63.8906 122.586 62.4844 123.594 60.4453 123.594C58.3828 123.594 56.9766 122.586 56.9766 121.062ZM58.2578 129.219V124.453H67.3828V129.219H58.2578ZM58.6641 121.062C58.6562 121.852 59.375 122.297 60.4453 122.297C61.5156 122.297 62.2422 121.852 62.2422 121.062C62.2422 120.297 61.5156 119.844 60.4453 119.844C59.375 119.844 58.6562 120.297 58.6641 121.062ZM59.9766 127.812H65.6641V125.828H59.9766V127.812ZM74.6484 116.25C76.8906 116.242 78.5234 117.656 78.5391 119.656C78.5234 121.664 76.8906 123.07 74.6484 123.078C72.4297 123.07 70.7656 121.664 70.7734 119.656C70.7656 117.656 72.4297 116.242 74.6484 116.25ZM70.1328 125.031C72.6797 125.031 76.2031 125 79.2578 124.562L79.3984 125.828C76.2344 126.43 72.8438 126.453 70.3516 126.453L70.1328 125.031ZM72.4922 119.656C72.4844 120.836 73.4141 121.562 74.6484 121.562C75.8984 121.562 76.8281 120.836 76.8359 119.656C76.8281 118.484 75.9062 117.75 74.6484 117.75C73.4141 117.75 72.4844 118.484 72.4922 119.656ZM80.1016 129.406V115.266H81.8359V129.406H80.1016ZM93.0391 118.656C93.0234 121.25 94.3906 123.844 96.6797 124.828L95.6484 126.219C94.0234 125.469 92.8359 123.977 92.1797 122.133C91.5312 124.117 90.3125 125.742 88.6016 126.547L87.5391 125.094C89.8906 124.078 91.2656 121.383 91.2734 118.656V116.406H93.0391V118.656ZM97.6953 129.406V115.266H99.4453V129.406H97.6953ZM106.586 117.719C106.586 119.461 107.703 121.172 109.93 121.906L109.055 123.25C107.469 122.719 106.352 121.664 105.734 120.344C105.109 121.789 103.938 122.938 102.289 123.5L101.367 122.156C103.641 121.398 104.836 119.57 104.836 117.719V117.547H101.852V116.156H109.523V117.547H106.586V117.719ZM103.258 125.828V124.438H112.664V129.391H110.93V125.828H103.258ZM110.93 123.781V115.266H112.664V118.797H114.633V120.25H112.664V123.781H110.93Z",
    fill: "#242424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_5295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.019 48.9995C119.019 75.5248 97.5238 97.0195 70.9985 97.0195C44.4732 97.0195 22.9785 75.5248 22.9785 48.9995C22.9785 22.4742 44.4732 0.979492 70.9985 0.979492C97.5238 0.979492 119.019 22.4742 119.019 48.9995Z",
    fill: "url(#paint0_linear_1275_5295)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1275_5295)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3358 51.4213C43.981 37.2487 54.35 24.6653 68.5226 23.3106C70.1639 23.1543 71.8052 23.1543 73.4465 23.3106C87.6191 24.6914 98.0141 37.2748 96.6594 51.4734C95.4088 64.7081 84.2844 74.7905 70.9976 74.7905C66.6728 74.7905 62.4002 73.6702 58.6226 71.586C58.336 71.4037 57.9713 71.3776 57.6587 71.4558L48.9831 74.061C48.5142 74.1913 48.0452 74.1913 47.5763 74.061C46.2737 73.6702 45.5442 72.3155 45.935 71.0129L48.5402 62.3374C48.6184 62.0247 48.5924 61.66 48.41 61.3734C46.7166 58.2992 45.6745 54.9124 45.3358 51.4213ZM62.3762 48.9985C62.3762 51.0272 60.7315 52.6719 58.7027 52.6719C56.674 52.6719 55.0293 51.0272 55.0293 48.9985C55.0293 46.9697 56.674 45.325 58.7027 45.325C60.7315 45.325 62.3762 46.9697 62.3762 48.9985ZM70.9996 52.6719C73.0283 52.6719 74.673 51.0272 74.673 48.9985C74.673 46.9697 73.0283 45.325 70.9996 45.325C68.9708 45.325 67.3262 46.9697 67.3262 48.9985C67.3262 51.0272 68.9708 52.6719 70.9996 52.6719ZM86.944 48.9985C86.944 51.0272 85.2994 52.6719 83.2706 52.6719C81.2418 52.6719 79.5972 51.0272 79.5972 48.9985C79.5972 46.9697 81.2418 45.325 83.2706 45.325C85.2994 45.325 86.944 46.9697 86.944 48.9985Z",
    fill: "#98A2B3"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1275_5295)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.9999,
    cy: 48.9999,
    r: 42.4906,
    stroke: "#98A2B3",
    strokeWidth: 2.56553
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_5295",
    x: 45.2168,
    y: 23.1934,
    width: 51.5605,
    height: 52.6229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5295"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_5295",
    x: 27.2266,
    y: 5.22656,
    width: 87.5469,
    height: 88.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5295"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_5295",
    x1: 37.6785,
    y1: 11.4328,
    x2: 107.749,
    y2: 79.3795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_5295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstComment);
export default __webpack_public_path__ + "static/media/FirstComment.6f9871956ad5898e473dd291cacbd6af.svg";
export { ForwardRef as ReactComponent };